import React, { Component } from "react";
import "../style/Search.css";
export class Search extends Component {
  render() {
    return (
      <div className="selected-category-holder">
        {this.props.selectedCategories.length < 1 && (
          <p className="instructions">Hover over a box to select a category</p>
        )}
        <ul className="categories">
          {this.props.selectedCategories.map(category => {
            return (
              <li
                className="selected-category"
                onClick={e => this.props.removeCategory(category)}
                key={category}
              >
                {category}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/components/Search.js